"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATIONS = void 0;
var LOCATIONS = {
  BUTTON__ADD_NEW_LOCATION: 'inventoryTransferLocations-button-addNewLocation',
  BUTTON__ADD_PRODUCT: 'inventoryAdditionLocations-button-addProduct',
  BUTTON__EDIT: 'inventoryAdditionLocations-button-edit',
  INPUT__SEARCH: 'inventoryAdditionLocations-input-search',
  ADD_LOCATION: {
    BUTTON__REMOVE: 'inventoryTransferAddLocationModal-button-removeLocation',
    INPUT__NAME: 'inventoryTransferAddLocationModal-input-locationName',
    BUTTON__ADD: 'inventoryTransferAddLocationModal-button-addLocation',
    BUTTON__CANCEL: 'inventoryTransferAddLocationModal-button-cancel',
    BUTTON__SAVE: 'inventoryTransferAddLocationModal-button-save'
  },
  MAP_PRODUCTS: {
    BUTTON__REMOVE: 'inventoryTransferMapProductsModal-button-removeProduct',
    SELECT__PRODUCT: 'inventoryTransferMapProductsModal-select-selectProduct',
    BUTTON__ADD: 'inventoryTransferMapProductsModal-button-addProduct',
    BUTTON__CANCEL: 'inventoryTransferMapProductsModal-button-cancel',
    BUTTON__SAVE: 'inventoryTransferMapProductsModal-button-save'
  }
};
exports.LOCATIONS = LOCATIONS;